module.exports = __webpack_public_path__ + "img/744.7ef9caf9.jpg";